export default 'mypartnership';
